<template>
  <div class="col-12 col-md-6 offset-md-3 my-4">
    <div class="row align-center" :class="{ blaProgressBarFixed: fixedHeader }">
      <div
        class="
          col-10
          offset-1
          col-md-8
          offset-md-2
          text-center
          blaProgressbarText
        "
      >
        <img
          :src="require('@/assets/img/close_icon.png')"
          alt="exit_icon"
          class="blaProgressBarIcon clickable"
          @click="showExitModal = true"
        />
        <!-- </div> -->
        <!-- <div class="col-8 offset-1 col-md-8 offset-md-1 text-center"> -->
        <!-- <div class="progress blaProgress">
          <div
            class="progress-bar blaProgressBar"
            role="progressbar"
            :aria-valuenow="currentPosition"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{ width: currentPosition + '%' }"
          ></div>
        </div> -->
        <img
          v-show="show"
          :src="require('@/assets/img/score_gray.png')"
          alt="lingron_ikon"
          class="blaProgressIcon"
        />
        <span v-show="show"> {{ currentPosition }} / {{ maxPosition }} </span>
      </div>
    </div>
    <div v-show="showExitModal" class="blaExitModal">
      <h4>Biztosan kilépsz?</h4>
      <p>A jelenlegi állapotot nem mentjük el</p>
      <div
        class="blaExitModalButton blaExitModalButtonLeft"
        @click="showExitModal = false"
      >
        MÉGSE
      </div>
      <div
        v-if="isFree"
        class="blaExitModalButton blaExitModalButtonRight text-danger"
        @click="goToFreeUrl"
      >
        KILÉPÉS
      </div>
      <div
        v-else
        class="blaExitModalButton blaExitModalButtonRight text-danger"
        @click="$router.push({ name: 'home' })"
      >
        KILÉPÉS
      </div>
    </div>
    <div v-show="showExitModal" class="blaExitModalBg"></div>
  </div>
</template>

<script>
export default {
  props: {
    currentPosition: { type: Number, default: 0 },
    maxPosition: { type: Number, default: 0 },
    fixedHeader: Boolean,
    show: { type: Boolean, default: true },
    isFree: { type: Boolean, default: false },
  },
  data: () => ({
    showExitModal: false,
  }),
  methods: {
    goToFreeUrl() {
      window.location.href = "https://e-egyetem.hu";
    },
  },
  mounted: function () {
    // if back button is pressed
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      let rt = false;
      window.onpopstate = function (event) {
        rt = true;
        console.log("saniyka");
        return rt;
      };

      let vm = this.$data;
      setTimeout(function () {
        if (rt) {
          vm.showExitModal = true;
          next(false);
        } else {
          next(true);
        }
      }, 500);

      // window.addEventListener('popstate', function() {
      //   console.log('tomas');
      // }, false);
    });

    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
};
</script>
